import PropTypes from 'prop-types';
import React from 'react';

const HorizontalRule = ({size, nodeIndex}) => {
  if (size && size !== 'thick') size = '';

  const hrAttrs = {};

  if (size) {
    hrAttrs.className = size;
  }

  return <hr key={nodeIndex} {...hrAttrs} />;
};

HorizontalRule.propTypes = {
  size: PropTypes.string,
  nodeIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default HorizontalRule;



// WEBPACK FOOTER //
// ./node_modules/@hpcare/component-wait-times/node_modules/@hppl/component-heading/node_modules/@hppl/component-hr/index.jsx